import { useCallback } from 'react';
import NiceModal from '@ebay/nice-modal-react';

import UiLocationIcon from '@/icons/UiLocationIcon';

import { modals } from '@/modals';
import PermissionRow from '@/app/pages/LobbyPage/PermissionRow';
import useLocationPermission from '@/app/hooks/useLocationPermission';

import './LobbyPage.css';
import { EVENTS, gtag } from '@/lib/gtag';

/**
 * The location row of the lobby checklist, mirroring the camera/microphone
 * lines. Location can be blocked on the site level or by the OS Location
 * Services, so a failed request opens the location reset modal with both
 * unblock paths.
 */
export default function LocationPermissionLine() {
  const { state, request } = useLocationPermission(true);

  const onRequestPermission = useCallback(() => {
    request().catch(() => {
      gtag(EVENTS.SHOW_MODAL, { location: true });
      NiceModal.show(modals.RESET_LOCATION_MODAL);
    });
  }, [request]);

  if (state === 'unsupported') {
    return null;
  }

  return (
    <PermissionRow
      Icon={UiLocationIcon}
      granted={state === 'granted'}
      name="Location"
      onEnable={onRequestPermission}
    />
  );
}
